"use client";
import { Slider } from "@/components/ui/slider";

interface RangeFieldProps {
  id: string;
  label: string;
  // Formatted current value shown after the label ("₹900", "4", "2%").
  output: string;
  ariaLabel: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (value: number) => void;
}

// A labelled slider with its live value beside the label - the preview's
// `.calc-f` range rows in the industry calculators.
const RangeField = ({
  id,
  label,
  output,
  ariaLabel,
  min,
  max,
  step,
  value,
  onChange,
}: RangeFieldProps) => (
  <div className="grid gap-2">
    <label htmlFor={id} className="text-[15px] font-semibold text-ink">
      {label}
      <output htmlFor={id} className="ml-1.5 font-extrabold text-primary">
        {output}
      </output>
    </label>
    <Slider
      id={id}
      aria-label={ariaLabel}
      min={min}
      max={max}
      step={step}
      value={[value]}
      onValueChange={([next]) => onChange(next)}
    />
  </div>
);

export default RangeField;
